<template>
  <div :style="stylechat">
    <router-view/>
    <!-- menu -->
    <div class="tabs-menu">
      <v-layout row wrap justify-center align-center style="height: 91px !important;">
        <v-flex xs4 sm4 md4 @click="selectMenu(1, '/homepage')">
          <v-layout row wrap column justify-center align-center>
            <v-badge
              overlap
              color="red"
              offset-y="20"
              offset-x="10"
              content="+99"
              v-if="parseInt(count_request) >= 100"
            >
              <v-icon :class="menu1">mdi-home</v-icon>
            </v-badge>
            <v-badge
              overlap
              color="red"
              offset-y="20"
              offset-x="10"
              :content="count_request"
              v-else-if="parseInt(count_request) != 0"
            >
              <v-icon :class="menu1">mdi-home</v-icon>
            </v-badge>
            <v-icon v-else :class="menu1">mdi-home</v-icon>
            <span :class="menu1">{{$t('LeftSide.header.homepage')}}</span>
          </v-layout>
        </v-flex>
        <v-flex xs4 sm4 md4 @click="selectMenu(2, '/listchat')">
          <v-layout row wrap column justify-center align-center>
            <v-badge
              overlap
              color="red"
              offset-y="20"
              offset-x="10"
              content="+99"
              v-if="parseInt(count_read) >= 100"
            >
              <v-icon :class="menu2">fa-solid fa-comment-dots</v-icon>
            </v-badge>
            <v-badge
              overlap
              color="red"
              offset-y="20"
              offset-x="10"
              :content="count_read"
              v-else-if="parseInt(count_read) != 0 && parseInt(count_read) != -1"
            >
              <v-icon :class="menu2">fa-solid fa-comment-dots</v-icon>
            </v-badge>
            <v-icon v-else :class="menu2">fa-solid fa-comment-dots</v-icon>
            <span :class="menu2">{{$t('LeftSide.header.chat')}}</span>
          </v-layout>
        </v-flex>
        <v-flex xs4 sm4 md4 @click="selectMenu(3, '/setting')">
          <v-layout row wrap column justify-center align-center>
            <v-icon :class="menu3">fa-solid fa-gear</v-icon>
            <span :class="menu3">{{$t('LeftSide.header.setting')}}</span>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import { sync } from 'vuex-pathify'
  export default {
    data () {
      return {
        menu1: 'select_menu ',
        menu2: 'nonselect_menu ',
        menu3: 'nonselect_menu ',
        tab: null,
        stylechat: {
          "--Menu-HeaderColor": "white",
          "--Menu-TabBackground": "white",
          "--Menu-Icon": "gray",
          "--Menu-IconActive": "#2662ae",
        },
        data_user: {},
      }
    },
    created () {
      this.themechat = {
        background: 'white',
        color: 'red'
      }
      var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
      this.data_user = user_profile['account']['profile']
      // console.log(this.themechat)
      var menu_select = this.$cookie.get('select_menu')
      if (menu_select === '1') {
        this.menu1 = 'select_menu '
        this.menu2 = 'nonselect_menu '
        this.menu3 = 'nonselect_menu '
        // แก้ไขเวลากดแท็บซ้ำแล้ว err
        this.$router.push('/homepage').catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else if (menu_select === '2') {
        this.menu1 = 'nonselect_menu '
        this.menu2 = 'select_menu '
        this.menu3 = 'nonselect_menu '
        // แก้ไขเวลากดแท็บซ้ำแล้ว err
        this.$router.push('/listchat').catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else if (menu_select === '3') {
        this.menu1 = 'nonselect_menu '
        this.menu2 = 'nonselect_menu '
        this.menu3 = 'select_menu '
        // แก้ไขเวลากดแท็บซ้ำแล้ว err
        this.$router.push('/setting').catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    computed: {
      ...sync('*'),
    },
    watch: {
      count_request () {
        // console.log(this.count_request)
      },
      count_read () {
        // console.log(this.count_read)
      },
      // socketmessage (data) {
      //   // console.log(data)
      //   // this.count_read = this.count_read + 1
      //   // this.getnotcountread()
      // },
    },
    methods: {
      getnotcountread () {
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/getnotreadcount', {
          tokenuser: this.data_user.tokenuser
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log('count_read: ', response.data.count_read)
            // if (response.data.count_read !== 0) {
            //   if (this.num_countread !== 0) {
            //     this.showcountread = true
            //   } else {
            //     this.showcountread = false
            //   }
            // } else {
            //   this.showcountread = false
            // }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      selectMenu (menu, path) {
        if (menu === 1) {
          this.menu1 = 'select_menu '
          this.menu2 = 'nonselect_menu '
          // แก้ไขเวลากดแท็บซ้ำแล้ว err
          this.$router.push(path).catch(error => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
          this.$cookie.set('select_menu', menu)
        } else if (menu === 2) {
          this.menu1 = 'nonselect_menu '
          this.menu2 = 'select_menu '
          // แก้ไขเวลากดแท็บซ้ำแล้ว err
          this.$router.push(path).catch(error => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
          this.$cookie.set('select_menu', menu)
        } else if (menu === 3) {
          this.menu1 = 'nonselect_menu '
          this.menu2 = 'nonselect_menu '
          this.menu3 = 'select_menu '
          // แก้ไขเวลากดแท็บซ้ำแล้ว err
          this.$router.push(path).catch(error => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
          this.$cookie.set('select_menu', menu)
        }
      }
    }
  }
</script>
<style lang="css" scoped>
  >>>.select_menu {
    color: var(--Menu-IconActive) !important;
  }
  >>>.nonselect_menu {
    color: var(--Menu-Icon) !important;
  }
  .tabs-menu {
    background-color: var(--Menu-TabBackground) !important;
    position: fixed;
    bottom: 0;
    height: 64px;
    width: 100%;
    border-top-style: solid;
    border-top-width: thin;
    border-top-color: #dfdcdc;
  }
  .toolbar-header-user {
    height: 64px;
    box-shadow: none !important;
    background: var(--HeaderBackground) !important;
  }
</style>
